import { useState, type ReactNode } from 'react';

import { Campo, Painel } from '../../comum';
import type { PropsSecao } from './comum';

/**
 * Identidade desta instalação.
 */
export function SecaoInstalacao({ c, podeEditar, acao, salvar }: PropsSecao): ReactNode {
  const [instalacao, setInstalacao] = useState(c.instalacao);

  return (
    <Painel
      titulo="Esta instalação"
      sub="Identifica o cliente nos relatórios e nos chamados abertos pela plataforma."
    >
      <Campo
        rotulo="Nome do cliente"
        ajuda="Aparece no cabeçalho do relatório executivo e no resumo enviado à diretoria."
      >
        <input
          value={instalacao.nomeDoCliente}
          maxLength={80}
          disabled={!podeEditar}
          onChange={(e) => setInstalacao({ ...instalacao, nomeDoCliente: e.target.value })}
        />
      </Campo>

      {/*
      🔴 Só dava para definir isto no assistente de primeira execução.
      Depois disso o nome ficava congelado — e ele aparece em todo relatório
      que sai do produto. Cliente que muda de razão social, ou instalação
      feita às pressas com "teste" no campo, não tinham correção.
    */}
      <p className="suave" style={{ fontSize: 12.5 }}>
        Instalação{' '}
        {instalacao.concluida
          ? `concluída em ${instalacao.concluidaEm?.slice(0, 10) ?? '—'}` +
            (instalacao.concluidaPor === null ? '' : ` por ${instalacao.concluidaPor}`)
          : 'ainda não concluída'}
        .
      </p>

      <button
        className="primario"
        disabled={acao.executando || !podeEditar}
        onClick={() => salvar('instalacao', instalacao, 'Instalação')}
      >
        Salvar
      </button>
    </Painel>
  );
}
